/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { CashFlowForecastRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import {
  CashFlowForecastDetails,
  cashFlowForecastDetailsFromDto,
  cashFlowForecastDetailsToDto,
} from './cash-flow-forecast.model';

@Injectable()
export class CashFlowForecastDetailsBusinessService implements InitViewService {
  constructor(private cashFlowForecastRest: CashFlowForecastRestService) {

  }

  initView(): any {
    return {
      details: this.init(),
    };
  }

  init(): Observable<CashFlowForecastDetails> {
    return this.cashFlowForecastRest.init().pipe(map$(cashFlowForecastDetailsFromDto));
  }

  update(details: CashFlowForecastDetails): Observable<CashFlowForecastDetails> {
    if (details.useVirtualSchedules) {
      return this.cashFlowForecastRest.update(cashFlowForecastDetailsToDto(details))
        .pipe(map$(cashFlowForecastDetailsFromDto));
    } else {
      return this.init();
    }
  }
}
